/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Extranet } from '../types';
// @ts-ignore
import type { UpdateExtranetBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * ExtranetsApi - axios parameter creator
 * @export
 */
export const ExtranetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the current extranet configuration based on request origin. No authentication required.
         * @summary Get current extranet (public)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentExtranet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/extranets/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an extranet
         * @summary Find extranet by ID
         * @param {string} extranetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtranet: async (extranetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extranetId' is not null or undefined
            assertParamExists('getExtranet', 'extranetId', extranetId)
            const localVarPath = `/extranets/{extranet_id}`
                .replace(`{${"extranet_id"}}`, encodeURIComponent(String(extranetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all extranets
         * @summary List all extranets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtranets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/extranets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an extranet and returns the updated extranet
         * @summary Update extranet by ID
         * @param {string} extranetId 
         * @param {UpdateExtranetBody} [updateExtranetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExtranet: async (extranetId: string, updateExtranetBody?: UpdateExtranetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extranetId' is not null or undefined
            assertParamExists('updateExtranet', 'extranetId', extranetId)
            const localVarPath = `/extranets/{extranet_id}`
                .replace(`{${"extranet_id"}}`, encodeURIComponent(String(extranetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExtranetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExtranetsApi - functional programming interface
 * @export
 */
export const ExtranetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExtranetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the current extranet configuration based on request origin. No authentication required.
         * @summary Get current extranet (public)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentExtranet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Extranet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentExtranet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtranetsApi.getCurrentExtranet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an extranet
         * @summary Find extranet by ID
         * @param {string} extranetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExtranet(extranetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Extranet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExtranet(extranetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtranetsApi.getExtranet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all extranets
         * @summary List all extranets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExtranets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Extranet>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExtranets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtranetsApi.getExtranets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an extranet and returns the updated extranet
         * @summary Update extranet by ID
         * @param {string} extranetId 
         * @param {UpdateExtranetBody} [updateExtranetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExtranet(extranetId: string, updateExtranetBody?: UpdateExtranetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Extranet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExtranet(extranetId, updateExtranetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtranetsApi.updateExtranet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExtranetsApi - factory interface
 * @export
 */
export const ExtranetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExtranetsApiFp(configuration)
    return {
        /**
         * Returns the current extranet configuration based on request origin. No authentication required.
         * @summary Get current extranet (public)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentExtranet(options?: RawAxiosRequestConfig): AxiosPromise<Extranet> {
            return localVarFp.getCurrentExtranet(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an extranet
         * @summary Find extranet by ID
         * @param {string} extranetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtranet(extranetId: string, options?: RawAxiosRequestConfig): AxiosPromise<Extranet> {
            return localVarFp.getExtranet(extranetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all extranets
         * @summary List all extranets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtranets(options?: RawAxiosRequestConfig): AxiosPromise<Array<Extranet>> {
            return localVarFp.getExtranets(options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an extranet and returns the updated extranet
         * @summary Update extranet by ID
         * @param {string} extranetId 
         * @param {UpdateExtranetBody} [updateExtranetBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExtranet(extranetId: string, updateExtranetBody?: UpdateExtranetBody, options?: RawAxiosRequestConfig): AxiosPromise<Extranet> {
            return localVarFp.updateExtranet(extranetId, updateExtranetBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExtranetsApi - object-oriented interface
 * @export
 * @class ExtranetsApi
 * @extends {BaseAPI}
 */
export class ExtranetsApi extends BaseAPI {
    /**
     * Returns the current extranet configuration based on request origin. No authentication required.
     * @summary Get current extranet (public)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtranetsApi
     */
    public getCurrentExtranet(options?: RawAxiosRequestConfig) {
        return ExtranetsApiFp(this.configuration).getCurrentExtranet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an extranet
     * @summary Find extranet by ID
     * @param {string} extranetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtranetsApi
     */
    public getExtranet(extranetId: string, options?: RawAxiosRequestConfig) {
        return ExtranetsApiFp(this.configuration).getExtranet(extranetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all extranets
     * @summary List all extranets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtranetsApi
     */
    public getExtranets(options?: RawAxiosRequestConfig) {
        return ExtranetsApiFp(this.configuration).getExtranets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an extranet and returns the updated extranet
     * @summary Update extranet by ID
     * @param {string} extranetId 
     * @param {UpdateExtranetBody} [updateExtranetBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtranetsApi
     */
    public updateExtranet(extranetId: string, updateExtranetBody?: UpdateExtranetBody, options?: RawAxiosRequestConfig) {
        return ExtranetsApiFp(this.configuration).updateExtranet(extranetId, updateExtranetBody, options).then((request) => request(this.axios, this.basePath));
    }
}

